import type { GameModule } from '../types';
import Page from './Page';

const cricket: GameModule = {
  id: 'cricket',
  displayName: 'Cricket',
  tag: "Sports",
  theme: {
    gradient: 'from-[#0A3C5F] via-[#002800] to-[#001A00]',
    emoji: '🏏',
  },
  orientation: 'any',
  Page,
};

export default cricket;
